import { render, staticRenderFns } from "./EChartsHorizontalBarChart.vue?vue&type=template&id=53401b2a&scoped=true"
import script from "./EChartsHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./EChartsHorizontalBarChart.vue?vue&type=script&lang=js"
import style0 from "./EChartsHorizontalBarChart.vue?vue&type=style&index=0&id=53401b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53401b2a",
  null
  
)

export default component.exports